// extracted by mini-css-extract-plugin
export default {"title-container":"Quote_title-container__LUhzs","heading":"Quote_heading__ZT-cB","float":"Quote_float__GeRuU","shadow":"Quote_shadow__m3t16","dissolve":"Quote_dissolve__Z5dGc"};